import React, { Component } from 'react';
import './sidebar.css';
import FallbackImageToolTip from './fallbackImageToolTip';
import FilterToolTip from './filterToolTip';
import SortingOptionToolTip from './sortingOptionToolTip';
import CroppingToolTip from './croppingToolTip';
import RadioButton from '../Form/radioButton';
import HexPicker from '../HexPicker/hexPicker';

import CustomSlider from '../Form/slider';

import { VelocityComponent } from 'velocity-react';
import 'velocity-animate';
import 'velocity-animate/velocity.ui';

class Sidebar extends Component {
  render() {
    return (
      <div className="App-sidebar">
        <form>
          <ul>
            <li>
              <h2>Content Source</h2>
            </li>
            <li>
              <label htmlFor="param-filter-type">
                Filter Type <FilterToolTip />
              </label>
              <fieldset>
                <RadioButton
                  value="media_library"
                  stateValue={this.props.filterType}
                  textValue="Media Library"
                  onChangeHandler={e => this.props.actions.setFilterType(e)}
                />
                <RadioButton
                  value="stream_id"
                  stateValue={this.props.filterType}
                  textValue="Stream ID"
                  onChangeHandler={e => this.props.actions.setFilterType(e)}
                />
                <RadioButton
                  value="product_id"
                  stateValue={this.props.filterType}
                  textValue="Product ID"
                  onChangeHandler={e => this.props.actions.setFilterType(e)}
                />
                <RadioButton
                  value="category_id"
                  stateValue={this.props.filterType}
                  textValue="Category ID"
                  onChangeHandler={e => this.props.actions.setFilterType(e)}
                />
              </fieldset>
            </li>
            {this.props.filterType !== 'media_library' && (
              <li>
                <label htmlFor="param-filter-value">Filter Value</label>
                <span>
                  The value of the filter you want to apply in order to grab an image. If the filter is stream_id, the
                  filter_value would be the actual id of the stream.
                </span>
                <input
                  type="text"
                  name="param-filter-value"
                  onChange={this.props.actions.setFilterValue}
                  value={this.props.filterValue}
                />
              </li>
            )}
            <li>
              <label htmlFor="param-sorting-option">
                Sorting Preferences <SortingOptionToolTip />
              </label>
              <fieldset>
                <RadioButton
                  value="recent"
                  stateValue={this.props.sortingOption}
                  textValue="Most Recent"
                  onChangeHandler={e => this.props.actions.setSortingOption(e)}
                />
                <RadioButton
                  value="shuffled"
                  stateValue={this.props.sortingOption}
                  textValue="Shuffled"
                  onChangeHandler={e => this.props.actions.setSortingOption(e)}
                />
                <RadioButton
                  value="photorank"
                  stateValue={this.props.sortingOption}
                  textValue="Photorank"
                  onChangeHandler={e => this.props.actions.setSortingOption(e)}
                />
                <RadioButton
                  value="rated"
                  stateValue={this.props.sortingOption}
                  textValue="Clickthrough Rate"
                  onChangeHandler={e => this.props.actions.setSortingOption(e)}
                />
                <RadioButton
                  value="media_position"
                  stateValue={this.props.sortingOption}
                  textValue="Manual Sorting"
                  onChangeHandler={e => this.props.actions.setSortingOption(e)}
                />
              </fieldset>
            </li>
            <li>
              <h2>Styling</h2>
            </li>
            <li>
              <label htmlFor="param-size">Image Resolution</label>
              <fieldset>
                <RadioButton
                  value="square"
                  stateValue={this.props.imageSize}
                  textValue="Square 90x90"
                  onChangeHandler={e => this.props.actions.setImageResolution(e)}
                />
                <RadioButton
                  value="thumbnail"
                  stateValue={this.props.imageSize}
                  textValue="Thumbnail 150x150"
                  onChangeHandler={e => this.props.actions.setImageResolution(e)}
                />
                <RadioButton
                  value="mobile"
                  stateValue={this.props.imageSize}
                  textValue="Mobile 320x320"
                  onChangeHandler={e => this.props.actions.setImageResolution(e)}
                />
                <RadioButton
                  value="normal"
                  stateValue={this.props.imageSize}
                  textValue="Normal 640x640"
                  onChangeHandler={e => this.props.actions.setImageResolution(e)}
                />
                <RadioButton
                  value="original"
                  stateValue={this.props.imageSize}
                  textValue="Original"
                  onChangeHandler={e => this.props.actions.setImageResolution(e)}
                />
              </fieldset>
            </li>
            <li>
              <label htmlFor="param-number-of-images">Number of Images</label>
              <CustomSlider
                id="param-number-of-images"
                name="param-number-of-images"
                defaultValue={this.props.numberOfImages}
                onChange={this.props.actions.setNumberOfImages}
                min={0}
                max={8}
                marks={{ 0: 'None', 4: '4 images', 8: '8 images' }}
              />
            </li>
            <li>
              <label htmlFor="param-padding-size">Padding Size</label>
              <CustomSlider
                id="param-padding-size"
                name="param-padding-size"
                defaultValue={this.props.paddingSize}
                onChange={this.props.actions.setPaddingSize}
                min={0}
                max={20}
                marks={{ 0: '0px', 10: '10px', 20: '20px' }}
              />
            </li>
            <li>
              <label htmlFor="param-images-per-row-in-mobile">Images per row in mobile</label>
              <CustomSlider
                id="param-images-per-row-in-mobile"
                name="param-images-per-row-in-mobile"
                defaultValue={this.props.imagesPerRowInMobile}
                onChange={this.props.actions.setImagesPerRowInMobile}
                min={1}
                max={4}
                marks={{ 1: '1 image', 2: '2 images', 3: '3 images', 4: '4 images' }}
              />
            </li>
            <li>
              <label htmlFor="param-cropping">
                Enable Cropping <CroppingToolTip />
              </label>
              <div className="toggle-wrapper">
                <input
                  type="checkbox"
                  name="param-cropping"
                  onChange={this.props.actions.setCropping}
                  value={this.props.cropping}
                />
                <label htmlFor="param-cropping">{this.props.cropping ? 'On' : 'Off'}</label>
              </div>
            </li>
            {this.props.cropping !== false && (
              <VelocityComponent animation="transition.slideLeftBigIn" duration={650} runOnMount={true}>
                <div>
                  <li>
                    <label htmlFor="param-crop-size">Crop Size</label>
                    <fieldset className="width-height-input">
                      <input
                        type="number"
                        name="param-crop-size-width"
                        min="5"
                        max="640"
                        onChange={this.props.actions.setCropWidth}
                        value={this.props.cropSize.width}
                      />
                      <label htmlFor="param-crop-width">Width</label>
                    </fieldset>
                    <span className="width-height-input-separator">x</span>
                    <fieldset className="width-height-input">
                      <input
                        type="number"
                        name="param-crop-size-height"
                        min="5"
                        max="640"
                        onChange={this.props.actions.setCropHeight}
                        value={this.props.cropSize.height}
                      />
                      <label htmlFor="param-crop-height">Height</label>
                    </fieldset>
                  </li>
                  <li>
                    <label htmlFor="param-crop-fit">Crop Fit</label>
                    <fieldset>
                      <RadioButton
                        value="cover"
                        stateValue={this.props.cropFit}
                        textValue="Cover"
                        onChangeHandler={e => this.props.actions.setCropFit(e)}
                      />
                      <RadioButton
                        value="contain"
                        stateValue={this.props.cropFit}
                        textValue="Contain"
                        onChangeHandler={e => this.props.actions.setCropFit(e)}
                      />
                    </fieldset>
                  </li>
                  {this.props.cropFit === 'cover' && (
                    <VelocityComponent animation="transition.slideLeftBigIn" duration={650} runOnMount={true}>
                      <li>
                        <label htmlFor="param-cropping">Crop Position</label>
                        <fieldset>
                          <RadioButton
                            value="center"
                            stateValue={this.props.cropPosition}
                            textValue="Center"
                            onChangeHandler={e => this.props.actions.setCropPosition(e)}
                          />
                          <RadioButton
                            value="attention"
                            stateValue={this.props.cropPosition}
                            textValue="Attention"
                            onChangeHandler={e => this.props.actions.setCropPosition(e)}
                          />
                          <RadioButton
                            value="entropy"
                            stateValue={this.props.cropPosition}
                            textValue="Entropy"
                            onChangeHandler={e => this.props.actions.setCropPosition(e)}
                          />
                        </fieldset>
                      </li>
                    </VelocityComponent>
                  )}
                  {this.props.cropFit === 'contain' && (
                    <VelocityComponent animation="transition.slideLeftBigIn" duration={650} runOnMount={true}>
                      <li>
                        <label htmlFor="param-cropping">Crop Background</label>
                        <fieldset>
                          <RadioButton
                            value="blur"
                            stateValue={this.props.cropBackground}
                            textValue="Blur"
                            onChangeHandler={e => this.props.actions.setCropBackground(e)}
                          />
                          <RadioButton
                            value="hex"
                            stateValue={this.props.cropBackground}
                            textValue="Hexadecimal"
                            onChangeHandler={e => this.props.actions.setCropBackground(e)}
                          />
                          {this.props.cropBackground === 'hex' && (
                            <VelocityComponent animation="transition.slideLeftBigIn" duration={650} runOnMount={true}>
                              <HexPicker
                                hexValue={this.props.cropBackgroundHex}
                                setCropBackgroundHex={this.props.actions.setCropBackgroundHex}
                              />
                            </VelocityComponent>
                          )}
                        </fieldset>
                      </li>
                    </VelocityComponent>
                  )}
                </div>
              </VelocityComponent>
            )}
            <li>
              <h2>Extras</h2>
            </li>
            <li>
              <label htmlFor="param-fallback-image">
                Fallback Image URL
                <FallbackImageToolTip />
              </label>
              <input
                type="text"
                name="param-filter-value"
                onChange={this.props.actions.setFallbackImage}
                value={this.props.fallbackImage}
              />
            </li>
            <li>
              <button onClick={this.props.actions.setSnippet}>Get code</button>
            </li>
          </ul>
        </form>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/sidebar.js